import {
    addDoc,
    collection,
    doc,
    getDoc,
    getDocs,
    query,
    setDoc,
    where,
    orderBy,
    limit
} from "firebase/firestore";
import {fireStoreDB} from "../../firebase/client-app";
import Promise from "bluebird";
import _ from "lodash";
import {DATA_LIMIT} from "../constants/blog.constant";

export {
    addMultipleBlogPostContents,
    addSingleBlogPostContent,
    updateSingleBlogPostContent,
    getSingleBlogPostContent,
    getSingleBlogPostContentByBlogPostId,
    searchBlogPostContents,
    searchBlogPostContentsWithSearchCriteria,
    prepareBlogPostContentsList
}

const collectionName = 'blog-post-contents';
const collectionReference = collection(fireStoreDB, collectionName);

const addMultipleBlogPostContents = (blogPostContents) => {
    return Promise.map(blogPostContents, async blogPostContent => {
        await addSingleBlogPostContent(blogPostContent);
    });
}

const addSingleBlogPostContent = (blogPostContent) => {
    blogPostContent.createdAt = new Date();
    blogPostContent.updatedAt = blogPostContent.createdAt;
    return addDoc(collectionReference, blogPostContent);
}

const updateSingleBlogPostContent = (blogPostContent) => {
    const documentReference = doc(fireStoreDB, collectionName, blogPostContent.id);
    blogPostContent.updatedAt = new Date();
    return setDoc(documentReference, blogPostContent);
}

const getSingleBlogPostContent = async (blogPostContentId) => {
    const documentReference = doc(fireStoreDB, collectionName, blogPostContentId);
    const blogPostContentDoc = await getDoc(documentReference);
    return prepareSingleBlogPostContent(blogPostContentDoc);
}

const getSingleBlogPostContentByBlogPostId = async (blogPostId) => {
    let searchQuery = query(collectionReference);
    searchQuery = query(searchQuery, where("blogPostId", "==", blogPostId));

    const blogPostContentResult = await getDocs(searchQuery);
    return prepareBlogPostContentsList(blogPostContentResult);
}

const searchBlogPostContents = async (searchText) => {
    let searchQuery = query(collectionReference);

    if (searchText) {
        searchQuery = query(collectionReference, where("textList", "array-contains", searchText));
    }

    searchQuery = query(searchQuery,
        orderBy('updatedAt', 'desc'));

    searchQuery = query(searchQuery, limit(DATA_LIMIT));

    const blogPostContentResult = await getDocs(searchQuery);
    return prepareBlogPostContentsList(blogPostContentResult);
}

const searchBlogPostContentsWithSearchCriteria = async (searchCriteriaList) => {
    let searchQuery = query(collectionReference);

    // console.log('searchBlogPostContentsWithSearchCriteria', {searchCriteriaList});

    _.forEach(searchCriteriaList, searchCriteria => {
        searchQuery = query(searchQuery,
            where(searchCriteria.field, searchCriteria.condition, searchCriteria.value));
    });

    searchQuery = query(searchQuery, limit(DATA_LIMIT));

    const blogPostContentResult = await getDocs(searchQuery);
    return prepareBlogPostContentsList(blogPostContentResult);
}

const prepareBlogPostContentsList = (blogPostContentResult) => {
    const blogPostContentsList = [];

    _.forEach(blogPostContentResult.docs, blogPostContentDoc => {
        blogPostContentsList.push(prepareSingleBlogPostContent(blogPostContentDoc));
    });

    return blogPostContentsList;
}

const prepareSingleBlogPostContent = (blogPostContentDoc) => {
    const blogPostContent = blogPostContentDoc.data();
    blogPostContent.id = blogPostContentDoc.id;
    return blogPostContent;
}
